import {
  Card,
  CaptionedImage,
  ClassicCard,
  ControlCard,
  ImageOnly,
} from "../index.js";
import {
  dateFromUnixTimestamp as l,
  rehydrateDateAfterJsonization as w,
} from "../../util/date-utils.js";
import r from "../../../shared-lib/braze-shared-lib.js";
export function newCard(e, n, t, o, i, l, u, d, a, s, w, f, m, C, p, c, x, F) {
  let b;
  if (n === Card.et.Ot || n === Card.et.Mt)
    b = new ClassicCard(e, t, o, i, l, u, d, a, s, w, f, m, C, p, c, x);
  else if (n === Card.et.ht)
    b = new CaptionedImage(e, t, o, i, l, u, d, a, s, w, f, m, C, p, c, x);
  else if (n === Card.et.Pt)
    b = new ImageOnly(e, t, i, u, d, a, s, w, f, m, C, p, c, x);
  else {
    if (n !== Card.et.Ut)
      return r.j.error("Ignoring card with unknown type " + n), null;
    b = new ControlCard(e, t, d, s, C, p);
  }
  return F && (b.test = F), b;
}
export function newCardFromContentCardsJson(e) {
  if (e[Card.Rt.Lt]) return null;
  const n = e[Card.Rt.rt],
    r = e[Card.Rt.st],
    t = e[Card.Rt.ot],
    o = e[Card.Rt.ct],
    i = e[Card.Rt.nt],
    u = e[Card.Rt.dt],
    d = l(e[Card.Rt.ut]),
    a = d;
  let s;
  s = e[Card.Rt.xt] === Card._t ? null : l(e[Card.Rt.xt]);
  return newCard(
    n,
    r,
    t,
    o,
    i,
    u,
    a,
    d,
    null,
    s,
    e[Card.Rt.URL],
    e[Card.Rt.bt],
    e[Card.Rt.gt],
    e[Card.Rt.jt],
    e[Card.Rt.zt],
    e[Card.Rt.kt],
    e[Card.Rt.qt],
    e[Card.Rt.vt] || !1,
  );
}
export function newCardFromFeedJson(e) {
  return newCard(
    e.id,
    e.type,
    e.viewed,
    e.title,
    e.image,
    e.description,
    l(e.created),
    l(e.updated),
    e.categories,
    l(e.expires_at),
    e.url,
    e.domain,
    e.aspect_ratio,
    e.extras,
    !1,
    !1,
  );
}
export function newCardFromSerializedValue(e) {
  return (
    newCard(
      e[Card.it.rt],
      e[Card.it.st],
      e[Card.it.ot],
      e[Card.it.ct],
      e[Card.it.nt],
      e[Card.it.dt],
      w(e[Card.it.lt]),
      w(e[Card.it.ut]),
      e[Card.it.ft],
      w(e[Card.it.xt]),
      e[Card.it.URL],
      e[Card.it.bt],
      e[Card.it.gt],
      e[Card.it.jt],
      e[Card.it.zt],
      e[Card.it.kt],
      e[Card.it.qt],
      e[Card.it.vt] || !1,
    ) || void 0
  );
}
